/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Primarystudyinterest2Inputs */

const en__field_primarystudyinterest2 = /** @type {(inputs: _Field_Primarystudyinterest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary Study Interest`)
};

const de__field_primarystudyinterest2 = /** @type {(inputs: _Field_Primarystudyinterest2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauptinteresse Studiengang`)
};

/**
* | output |
* | --- |
* | "Primary Study Interest" |
*
* @param {_Field_Primarystudyinterest2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_primarystudyinterest2 = /** @type {((inputs?: _Field_Primarystudyinterest2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Primarystudyinterest2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_primarystudyinterest2(inputs)
	return de__field_primarystudyinterest2(inputs)
});
export { _field_primarystudyinterest2 as "_field_primaryStudyInterest" }